import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"


import Seo from "./seo"

const Layout = ({ children}) => {
 
  return (
    <StaticQuery
      query={graphql`
      query {
        strapiMainPage {
          id
          Title
          Description
          TopLogo {
            publicURL
          }
          BackgroundImage {
            publicURL
          }          
          SEOfields {
            og_description
            og_locale
            og_title
            og_type
            og_url
          }
          LogoMobile{
            publicURL
          }
          MainColor
          SecondaryColor
          OffColor
        }
      }
      `}
/*       render={data => (
        <div className="uk-section">
          <div className="uk-container uk-container-large">
            <h1>Simulador</h1>
              <      nxquestoes={data.allStrapiQuestao.edges}></Questao>
          </div>
        </div>
      )} */
      
      render={data => {
        return(
          <div className="backgroundColor" style={{height: "100%", width: "100%",  position: "fixed"}}>      
          <Seo title= {"Simulador"} SEOfields={data.strapiMainPage.SEOfields}/>
          <div id="background" > </div>  
          <main id="mainElement">       
          
          <style>{
              `#background {
                background:url('`+data.strapiMainPage.BackgroundImage.publicURL+`');
                background-size: contain;
                background-repeat: no-repeat;
                background-position: 50% 96%;
                height: 329%;
                width: 225%;
                position: fixed;
                transform: rotate(var(--dir));
                bottom: -19%;
                right: -60%;
                transition: transform 3s;
                transform-origin: center;
              }
              :root {
                --main-color:`+data.strapiMainPage.MainColor+`; /* estas cores são para definir por api */ 
                --secondary-color: `+data.strapiMainPage.SecondaryColor+`; 
                --off-color:`+data.strapiMainPage.OffColor+`;
                --nuno-color:#fa6b2e;
                --esq: 35deg;
                --dir: 0deg;
              }
              
              @media only screen and (max-width: 450px) {
                #background {                
                  transform: scale(1.2) ;            
                }
              .toplogo img {
                content: url('`+data.strapiMainPage.LogoMobile.publicURL+`');
              }
             
              `}
              </style> 
               
            <div className="" style={{minHeight: "92%"}}>
             
              <div className="TitleDiv uk-container uk-container-large">
                <div className="toplogo">
                  <a href="/"><img src={data.strapiMainPage.TopLogo.publicURL}></img></a>
                </div>
                <div class="line" style={{border:"solid 1px var(--off-color)", backgroundColor:"var(--off-color)", margin:"0px auto 5px auto", width:"7%"}}></div>
                {children}
              </div>
              
            </div> 
            <footer className="footer text-white">
                <div>
                  <Link className="whiteLink" to="/privacypolicy">Política de Privacidade e Cookies  .  </Link>                  
                  <Link  className="whiteLink" to="/contact">Contacto</Link>
                </div>
                <span className="float-right">
                  @ Valey Innovation 2020
                </span>
              </footer>            
          </main>
          </div>

        )
    }}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
